import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = 
[
  {
    label: 'Home',
    icon: 'HamburgerCloseIcon',
    href: 'https://borgswap.exchange/',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://swap.borgswap.exchange/#/swap'
      },
      {
        label: 'Liquidity',
        href: 'https://swap.borgswap.exchange/#/pool'
      }
    ]
  },
  {
    label: 'Layers',
    icon: 'HomeIcon',
    items: [
      {
        label: 'Klingon Layer',
        href: 'https://farm.borgswap.exchange/',
      },
      {
        label: 'Tribble Layer',
        href: 'https://tribbles.borgswap.exchange/',
      },
      {
        label: 'Spock Layer',
        href: 'https://vulcans.borgswap.exchange/',
      },
      {
        label: 'Odo Layer',
        href: 'https://odo.borgswap.exchange/',
      },
      {
        label: 'Seven of Nine Layer',
        href: 'https://son.borgswap.exchange/',
      },
    ],
  },
  {
    label: 'Layered Farms',
    icon: 'FarmIcon',
    items: [
      {
        label: 'Klingon Layer',
        href: 'https://farm.borgswap.exchange/Farms',
      },
      {
        label: 'Klingon: Yield Inception',
        href: 'https://farm.borgswap.exchange/YieldInception',
      },
      {
        label: 'Tribble Layer',
        href: 'https://tribbles.borgswap.exchange/Farms',
      },
      {
        label: 'Spock Layer',
        href: 'https://vulcans.borgswap.exchange/Farms',
      },
      {
        label: 'Odo Layer',
        href: 'https://odo.borgswap.exchange/Farms',
      },
      {
        label: 'Seven of Nine Layer',
        href: 'https://son.borgswap.exchange/Farms',
      },
    ],
  },
  {
    label: 'Layered Burn Backs',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Klingon Layer',
        href: 'https://farm.borgswap.exchange/BurnBacks',
      },
      {
        label: 'Tribble Layer',
        href: 'https://tribbles.borgswap.exchange/BurnBacks',
      },
      {
        label: 'Spock Layer',
        href: 'https://vulcans.borgswap.exchange/BurnBacks',
      },
      {
        label: 'Odo Layer',
        href: 'https://odo.borgswap.exchange/BurnBacks',
      },
      {
        label: 'Seven of Nine Layer',
        href: 'https://son.borgswap.exchange/BurnBacks',
      },
    ],
  },
  {
    label: 'Layered Staking',
    icon: 'PoolIcon',
    items: [
      {
        label: 'Klingon Layer',
        href: 'https://farm.borgswap.exchange/Stake',
      },
      {
        label: 'Tribble Layer',
        href: 'https://tribbles.borgswap.exchange/Stake',
      },
      {
        label: 'Spock Layer',
        href: 'https://vulcans.borgswap.exchange/Stake',
      },
      {
        label: 'Odo Layer',
        href: 'https://odo.borgswap.exchange/Stake',
      },
      {
        label: 'Seven of Nine Layer',
        href: 'https://son.borgswap.exchange/Stake',
      },
    ],
  },
  {
    label: 'Assimilate Staking',
    icon: 'IfoIcon',
    href: 'https://farm.borgswap.exchange/Assimilate',
  },
  {
    label: 'Klingon Pools',
    icon: 'GroupsIcon',
    href: 'https://farm.borgswap.exchange/Pools',
  },
  {
    label: 'Ferengi Vaults',
    icon: 'HamburgerIcon',
    items: [
      {
        label: 'Ecosystem Token Info',
        href: 'https://farm.borgswap.exchange/Info',
      },
      {
        label: 'Vaults',
        href: 'https://www.rulesofaquisition.com/',
      },
    ],
  },
  {
    label: 'Info',
    icon: 'InfoIcon',
    items: [
      {
        label: 'Tribble Price Chart',
        href: 'https://dex.guru/token/0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068-bsc',
      },
      {
        label: 'Tribble Contract',
        href: 'https://bscscan.com/token/0xa5b5b9ec7db8e7d181fc25525b68e0fe3c6fe068',
      },
      {
        label: 'MasterTribble Contract',
        href: 'https://bscscan.com/address/0xa1feaee6253d389cf88d3ba65c21f964725b9172#code',
      },
    ],
  },
  {
    label: "Security Audit",
    icon: 'HelmetIcon',
    href: "https://github.com/TechRate/Smart-Contract-Audits/blob/main/BorgSwap.pdf",
  },
  {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      {
        label: "Blog",
        href: "https://medium.com/theborgtoken",
      },
      {
        label: "Documentation",
        href: "https://docs.borgswap.exchange",
      },
      {
        label: "Github",
        href: "https://github.com/locutusofborg111",
      },
      {
        label: 'Roadmap',
        href: 'https://farm.borgswap.exchange/roadmap',
      },
    ],
  },
]

export default config
